import { SvgIcon } from '@mui/material';

const RealtimeTracking = props => (
  <SvgIcon width='25' height='25' viewBox='0 0 25 25' {...props}>
    <g id='Group_143' data-name='Group 143' transform='translate(-7354 -6318)'>
      <circle
        id='Ellipse_4'
        data-name='Ellipse 4'
        cx='12.5'
        cy='12.5'
        r='12.5'
        transform='translate(7354 6318)'
        fill='#fff'
      />
      <g
        id='Group_20'
        data-name='Group 20'
        transform='translate(7360.482 6323.051)'
      >
        <path
          id='Path_5'
          data-name='Path 5'
          d='M119.914,94.964l-1.93,1.114,1.93,1.114,1.93-1.114Z'
          transform='translate(-113.881 -91.662)'
          fill='#dc0032'
        />
        <path
          id='Path_6'
          data-name='Path 6'
          d='M185.991,152l1.93-1.114v-2.229l-1.93,1.114Z'
          transform='translate(-179.524 -143.492)'
          fill='#dc0032'
        />
        <path
          id='Path_7'
          data-name='Path 7'
          d='M105.484,150.89l1.93,1.114v-2.229l-1.93-1.114Z'
          transform='translate(-101.817 -143.492)'
          fill='#dc0032'
        />
        <g id='Group_21' data-name='Group 21'>
          <g id='Group_20-2' data-name='Group 20' clipPath='url(#clip-path)'>
            <path
              id='Path_8'
              data-name='Path 8'
              d='M6.032,0A6.032,6.032,0,0,0,0,6.032c0,3.665,4.277,7.335,5.628,8.7a.569.569,0,0,0,.808,0c1.351-1.361,5.628-5.032,5.628-8.7A6.032,6.032,0,0,0,6.032,0M9.266,7.649a.435.435,0,0,1-.217.376L6.25,9.641l0,0a.433.433,0,0,1-.048.024h0a.436.436,0,0,1-.046.016l-.013,0L6.1,9.694l-.013,0a.4.4,0,0,1-.1,0l-.013,0-.039-.008-.013,0L5.87,9.668h0a.424.424,0,0,1-.048-.024l0,0-2.8-1.616A.435.435,0,0,1,2.8,7.649V4.416s0,0,0,0a.421.421,0,0,1,0-.053v0a.436.436,0,0,1,.01-.048l0-.013q.006-.019.013-.038l0-.013A.45.45,0,0,1,2.857,4.2h0a.439.439,0,0,1,.029-.043l.008-.011.026-.03.009-.009a.437.437,0,0,1,.037-.032l0,0a.435.435,0,0,1,.044-.03l0,0,2.8-1.616a.435.435,0,0,1,.435,0l2.8,1.616,0,0a.43.43,0,0,1,.044.03l0,0a.425.425,0,0,1,.036.032l.009.01.026.03.009.011a.442.442,0,0,1,.029.043h0a.443.443,0,0,1,.023.046l0,.013q.007.019.013.038l0,.013a.42.42,0,0,1,.01.048v0a.427.427,0,0,1,0,.053s0,0,0,0Z'
              fill='#dc0032'
            />
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export default RealtimeTracking;
